<template>
  <div class="mt-4 sidebar-navigation">
    <div class="grid grid-cols-1 gap-4">
      <div 
        class="object-center col-span-1"
        @click="navToggle()"
      >
        <font-awesome-icon
          title="Open menu"
          class="mb-6 text-xl text-gray-300 transition-all duration-200 ease-in-out cursor-pointer hover:text-white"
          icon="angles-right"
        />
      </div>
    </div>
    <div class="grid grid-cols-1 gap-4">
      <div class="col-span-1">
        <div
          v-for="tierOneItem in navItems.filter(item => !item.hidden)"
          :key="tierOneItem.name"
          :disabled="tierOneItem.disabled"
        >
          <div
            class="h-[43px] border-b border-gray-200 cursor-pointer flex flex-col justify-center items-center"
            @click="clickTierOne(tierOneItem)"
          >
            <font-awesome-icon
              v-if="tierOneItem.icon"
              :icon="tierOneItem.icon.name"
              :class="tierOneItem.icon.class "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    navItems: {
      type: Array,
      default: () => [],
    },
    navToggle: {
      type: Function,
      default: () => null,
    },
  },
  emits: ['onClick'],
  setup(props, context) {
    const clickTierOne = (tierOneItem) => {
      context.emit('onClick', [tierOneItem])
    }

    return {

      clickTierOne,
    }
  },
}
</script>
